<script setup lang="ts">
import { AlertCircle, CheckCircle2 } from '@lucide/vue'
import type { PushChannelTestResult } from './types'

defineProps<{
  result: PushChannelTestResult | null | undefined
}>()
</script>

<template>
  <div
    v-if="result"
    class="test-status-banner"
    :class="{ success: result.success, error: !result.success }"
  >
    <component :is="result.success ? CheckCircle2 : AlertCircle" :size="14" class="status-icon" />
    <span class="status-msg">{{ result.message }}</span>
    <span v-if="result.latencyMs" class="status-latency">{{ result.latencyMs }}ms</span>
  </div>
</template>

<style scoped>
.test-status-banner {
  display: flex;
  align-items: center;
  gap: var(--rr-space-2);
  font-size: var(--rr-font-size-sm);
  padding: var(--rr-space-2) var(--rr-space-3);
  border-radius: var(--rr-radius-control);
  margin-bottom: var(--rr-space-2);
}
.test-status-banner.success {
  background: var(--rr-color-success-soft);
  color: var(--rr-color-success);
}
.test-status-banner.error {
  background: var(--rr-color-danger-soft);
  color: var(--rr-color-danger);
}
.status-msg {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.status-latency {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: var(--rr-font-weight-bold);
  font-size: var(--rr-font-size-xs);
}
</style>
